export default "/images/vendor/@coreui/icons/svg/flag/cif-sb.svg?8dd43f00be16596d7a788245034cfd06";